export const NOTIFICATION_ADD = 'NOTIFICATION_ADD_WC';
export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE_WC';
